import { useIsPublicPage } from "lib/routing";
import { tryDoFetch } from "lib/tryDoFetch";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { miscSlice } from "redux/slices/miscSlice";

const COVER_IMAGE_DATA_URL = "/research/japi/content/assets/static/featuredimage.json";

export const CoverImageDataProvider = ({ children }) => {
  const dispatch = useDispatch();
  const isPublicPage = useIsPublicPage();

  useEffect(() => {
    async function fetchData() {
      if (isPublicPage) return;
      const coverImageData = await tryDoFetch(COVER_IMAGE_DATA_URL, null, "GET", console.error);
      if (coverImageData) dispatch(miscSlice.actions.set({ key: "coverImageData", value: coverImageData }));
    }
    fetchData();
  }, [dispatch, isPublicPage]);

  return children;
};
